import React, { forwardRef, useEffect } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import { addHours } from "date-fns";

import { ReactComponent as ClockIcon } from "../../../build/images/icons/Clock.svg";

import "./time-range.css";

export default function TimeRange({
    selected,
    setDate,
    dateFormat,
    timeIntervals = 15,
    minTime,
    maxTime,
}) {
    registerLocale("pt-BR", ptBR);
    setDefaultLocale("pt-BR");

    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="input-time-range" onClick={onClick} ref={ref}>
            {value}
            <ClockIcon />
        </div>
    ));

    const filterOutTime = (time) => {
        const selectedDate = new Date(time);

        return minTime.getTime() < selectedDate.getTime();
    };

    //USE EFFECTS
    // useEffect(() => {
    //     if (selected === maxTime && selected?.getTime() <= minTime?.getTime()) {
    //         setDate(addHours(minTime, 1));
    //     }
    // }, [minTime, maxTime]);

    return (
        <div className="time-range-custom">
            <DatePicker
                customInput={<CustomInput />}
                selected={selected}
                onChange={(date) => setDate(date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={timeIntervals}
                timeCaption={false}
                dateFormat={dateFormat}
                showPopperArrow={false}
                filterTime={selected === maxTime ? filterOutTime : false}
                openToDate={null}
            />
        </div>
    )
}
